import React from "react";
import { Alert, Card, Flex, Typography } from "antd";
import OrgBasicDetails from "../OrgBasicDetails/OrgBasicDetails";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import AuthService from "../../../../Service/auth.service";
import useOrganization from "../../../../Hooks/useOrganization";
import googleAnalyticService from "../../../../Service/google.analytic.service";
import { Plan } from "../../../../Entities/Plan";

interface OrgOnBoardingProps {
  plan: Plan | null;
}

const OrgOnBoarding: React.FC<OrgOnBoardingProps> = ({ plan }) => {
  const navigate = useNavigate();
  const { org } = useOrganization();

  const emitGoogleAnalyticsEvent = () => {
    googleAnalyticService.handleSubmissionEvents({
      category: "Organization Onboarding",
      action: "onboarding_completed_successfully",
      organization_name: org?.orgName,
      selected_plan_name: plan?.name,
      label: `${org?.orgName} Completed Onboarding , and selected plan ${plan?.name}`,
    });
  };

  const hasPendingSession = !!sessionStorage.getItem("pending_screening_session_id");

  const onOnboardingFinish = () => {
    emitGoogleAnalyticsEvent();
    AuthService.getInstance().handleInitialSetupDone();
    navigate("/user-onboarding", { replace: true });
  };

  return (
    <Flex vertical justify="center" gap={16} align="center" style={{ width: '100%', height: '100%', overflowY: 'auto' }}>
      <div className="onboarding-container">

        <Card className="onboarding-card">
          <div className="onboarding-header">
            <div className="header-content">
              <Typography.Title level={2} className="onboarding-title">
                Let's Get Your Organization Setup!
              </Typography.Title>
              {hasPendingSession ? (
                <Typography.Paragraph className="onboarding-subtitle">
                Your profile screening results are saved. Complete your organization setup to continue.
                </Typography.Paragraph>
              ) : (
                <Typography.Paragraph className="onboarding-subtitle">
                  This information helps us personalize your hiring experience and
                  ensure accurate billing
                </Typography.Paragraph>
              )}
            </div>
          </div>
          <div className="onboarding-content">
            <OrgBasicDetails onOnboardingFinish={onOnboardingFinish} />
          </div>
        </Card>
      </div>
    </Flex>
  );
};

export default OrgOnBoarding;
